import "antd/dist/antd.css";
import React, { useMemo } from "react";
import { connect } from "react-redux";
import { Tooltip, PieChart, Pie, Cell } from "recharts";
import { Typography } from "antd";
import { getBenefitsData, CustomTooltip } from "../Logics/summaryHelper";
import { benefitColors, generalHeight } from "./PieHelper";

const { Title } = Typography;

const BenefitsPie = (props) => {
  /**
   * Renders a Pie chart using the benefits data inputed on the beneftis page.
   * Must pass width.
   */

  const benefitsData = useMemo(() => getBenefitsData(), [props.benefitsDetails]);

  const getTitle = () => {
    for (const dataPoint of benefitsData) {
      if (dataPoint.value) {
        return "Benefits";
      }
      return "Enter benefits data for a breakdown";
    }
  };

  const renderCustomizedLabelBenefits = ({ cx, cy, midAngle, outerRadius, percent, index }) => {
    const RADIAN = Math.PI / 180;
    const radius = outerRadius * 1.05;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    var text = "";
    if ((percent > 0.03 && props.width > 1000) || percent > 0.06) {
      text = benefitsData[index].name;
    }

    return (
      <text x={x} y={y} fill="black" textAnchor={x > cx ? "start" : "end"} dominantBaseline="central">
        {text}
      </text>
    );
  };

  return (
    <div>
      <Title level={4}>{getTitle()}</Title>
      <PieChart width={props.width - 20} height={generalHeight(props.width, benefitsData, 0.35)}>
        <Pie
          blendStroke
          data={benefitsData}
          dataKey="value"
          nameKey={"overviewPie"}
          cx={"50%"}
          cy={"50%"}
          outerRadius={props.width * 0.15}
          fill="#8884d8"
          labelLine={false}
          label={renderCustomizedLabelBenefits}
          isAnimationActive={false}
        >
          {benefitsData.map((_, index) => (
            <Cell key={`cell-${"overviewPie" + index}`} fill={benefitColors[index]} />
          ))}
        </Pie>
        <Tooltip content={<CustomTooltip />}></Tooltip>
      </PieChart>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    benefitsDetails: state.benefits.benefitsDetails,
  };
};

export default connect(mapStateToProps, null)(BenefitsPie);
